import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/manga';

const categoryList = [
  {
    key: 'kr',
    icon: 'ri-heart-pulse-fill',
    bgImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%2C%20beautiful%20couple%20in%20modern%20Seoul%20setting%2C%20warm%20romantic%20atmosphere%2C%20soft%20pastel%20colors%2C%20Korean%20webtoon%20art%20style%2C%20clean%20and%20simple%20composition&width=600&height=400&seq=cat-kr-2026&orientation=landscape',
  },
  {
    key: 'jp',
    icon: 'ri-sun-fill',
    bgImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20illustration%2C%20cherry%20blossom%20and%20anime%20style%20characters%2C%20vibrant%20colors%2C%20soft%20dreamy%20atmosphere%2C%20shojo%20and%20shonen%20mix%20aesthetic%2C%20clean%20composition%2C%20warm%20lighting&width=600&height=400&seq=cat-jp-2026&orientation=landscape',
  },
  {
    key: 'cn',
    icon: 'ri-fire-fill',
    bgImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20fantasy%20illustration%2C%20ancient%20Chinese%20warrior%20with%20sword%2C%20mystical%20mountain%20landscape%2C%20warm%20golden%20and%20red%20tones%2C%20Chinese%20ink%20painting%20influence%2C%20clean%20dramatic%20composition&width=600&height=400&seq=cat-cn-2026&orientation=landscape',
  },
];

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类别探索你喜欢的漫画</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {categoryList.map((cat) => (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className="group relative rounded-xl overflow-hidden h-48 md:h-56"
            >
              <img
                src={cat.bgImage}
                alt={`${categoryMap[cat.key]} 漫画分类`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-500/90 rounded-full">
                    <i className={`${cat.icon} text-white text-sm`}></i>
                  </div>
                  <span className="text-white text-lg font-heading">{categoryMap[cat.key]}</span>
                </div>
                <p className="text-white/70 text-xs mt-1">点击探索更多{categoryMap[cat.key]}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}